import { Button } from "primereact/button";
import React, { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import AddEditUser from "./AddEditUser";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";
import { Dropdown } from "primereact/dropdown";
import { Formik, useFormik } from "formik";
import * as Yup from "yup";
import classNames from "classnames";
import { useSelector } from "react-redux";
import axios from "axios";
import appUrl from "../../../config/appUrl";
const UserManagement = () => {
  const [userdataId, setUserDataId] = useState("");
  const [addEditUser, setAddEditUser] = useState(false);
  const [userList, setUserList] = useState([]);
  const [userRole, setUserRole] = useState([]);
  const [displayDialog, setDisplayDialog] = useState(false);
  const [filteredUserList, setFilteredUserList] = useState([]);
  const [roleName, setRoleName] = useState({});
  const loginUser = useSelector((state) => state.loginUser);
  const { user } = loginUser;
  console.log("roleName", roleName);

  const validationSchema = Yup.object().shape({
    // name: Yup.mixed().required("This field is required."),
  });
  console.log("userList", userList);
  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      role: "",
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);

  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const editUsers = (rowData) => {
    setDisplayDialog(true);
    setAddEditUser(true);
    setUserDataId(rowData?._id);
  };

  const onHide = (name) => {
    setDisplayDialog(false);
  };

  const handleDialog = () => {
    setDisplayDialog(true);
  };

  const getUserList = async () => {
    try {
      let response;
      if (user?.site !== null) {
        response = await fetch(
          `${appUrl.BASE_URL}user?role=${formik?.values?.role}&site=${user?.site}`
        );
      } else {
        response = await fetch(
          `${appUrl.BASE_URL}user?role=${formik?.values?.role}`
        );
      }
      const data = await response?.json();
      const currentUser = JSON.parse(localStorage.getItem("user"));
console.log("currentUser", currentUser)
      // Filter out the current user
      const filteredUsers = data.filter(u => u._id !== currentUser._id);
  console.log("filteredUsers", filteredUsers)
  console.log("data", data)
      setUserList(filteredUsers);
      // setUserList(data);
      //setFilteredUserList(data); // Initially, set the filtered list to the entire list
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    storageData();
  }, []);

  useEffect(() => {
    getRoleOption();
  }, [roleName]);

  useEffect(() => {
    getUserList();
    // if(formik.values.role){
    //   getUserList();

    // }

    // if (user?.role) {
    //   formik.setFieldValue("role", user.role);
    //   handleRoleChange(user.role);
    // }
  }, [formik?.values?.role]);

  const statusTemp = (rowData) => {
    return <>{rowData.status === true ? "Active" : "InActive"}</>;
  };

  const nameTemp = (rowData) => {
    return <>{`${rowData.firstName} ${rowData.lastName}`}</>;
  };

  const actionTemp = (rowData) => {
    return (
      <div className="flex">
        <Button
          tooltip="Edit"
          icon="pi pi-user-edit"
          tooltipOptions={{ position: "top" }}
          onClick={() => editUsers(rowData)}
          className="p-button-rounded p-button-text"
        />
        <Button
          tooltip="Delete"
          tooltipOptions={{ position: "top" }}
          onClick={() => confirm(rowData)}
          icon="pi pi-trash"
          className="p-button-rounded p-button-text"
        />
      </div>
    );
  };

  const confirm = (rowData) => {
    confirmDialog({
      message: "Do you want to delete this record?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-primary",
      rejectClassName: "p-button-danger",
      accept: () => onDeleteConfirmation(rowData),
      reject,
    });
  };

  const onDeleteConfirmation = async (rowData) => {
    try {
      const response = await fetch(
        `${appUrl.BASE_URL}user?userId=${rowData?._id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();

      if (response.ok) {
        toast.success("User Deleted");
        await getUserList();
      } else {
        console.error(data?.msg); // Error message from the API
      }
    } catch (error) {
      console.error(error);
    }
  };

  const reject = () => {};

  const roleOptions = [
    { name: "Admin", value: "admin" },
    { name: "Site Admin", value: "site_admin" },
    { name: "Login User", value: "login_user" },
    { name: "Super Admin", value: "super_admin" },
  ];

  const storageData = () => {
    const storedLoginRes = JSON.parse(localStorage.getItem("user"));
    const userTypeIs = storedLoginRes?.role;
    setRoleName({ role: userTypeIs?.role });
  };

  const getRoleOption = async () => {
    try {
      const response = await axios.get(
        `${appUrl.BASE_URL}role?role=${roleName?.role}`
      );
      // const data = await response.json();
      setUserRole(response?.data?.data);
      console.log("data", response?.data);
      // setFilteredUserList(data); // Initially, set the filtered list to the entire list
    } catch (error) {
      console.error(error);
    }
  };

  const handleRoleChange = (selectedRole) => {
    // Filter the userList based on the selected role
    const filteredUsers = userList?.filter(
      (user) => user.role === selectedRole
    );
    setFilteredUserList(filteredUsers);
  };

  const canAddNewUser =
    userRole && (userRole === "admin" || userRole === "super_admin");

  return (
    <>
      <Dialog
        draggable={false}
        visible={displayDialog}
        style={{ width: "55vw" }}
        onHide={() => onHide("displayDialog")}
      >
        <AddEditUser
          onHide={onHide}
          getUserList={getUserList}
          addEditUser={addEditUser}
          userdataId={userdataId}
          allUsers={userList}
        />
      </Dialog>

      <ConfirmDialog />

      <div>
        <div className="p-fluid grid align-items-center">
          <div className="col-12 md:col-6">
            <div className="flex align-items-center">
              <h5
                className="mt-0 text-2xl mb-0 font-semibold text-[#17171B]"
                style={{ color: "#17171B" }}
              >
                User Management
              </h5>
            </div>
          </div>
          <div className="col-6 flex align-items-center justify-content-end">
            <div className=" col-12 md:col-4">
              {/* <label style={{ fontWeight: "bold" }}>Role</label> */}
              <Dropdown
                id="role"
                name="role"
                value={formik.values.role}
                onChange={formik.handleChange}
                filter
                filterBy="name,value"
                filterMatchMode="contains"
                className={classNames(
                  { "p-invalid": isFormFieldValid("role") },
                  "TextArea__Round border-round-3xl"
                )}
                options={userRole}
                optionValue="role"
                optionLabel="title"
                placeholder="Select Role"
                showClear  
              />
              {getFormErrorMessage("role")}
            </div>
            {roleName.role === "super_admin" && (
              <div className="col-12 md:col-4 text-right">
                <Button
                  label="Add New"
                  className="Add__New-Button"
                  aria-label="Add User"
                  onClick={() => {
                    handleDialog();
                    setAddEditUser(false);
                  }}
                  icon="pi pi-plus"
                 iconPos="left"
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="card custom_card p-datatable-sm">
        <DataTable
          scrollable
          // scrollHeight="382px"
          responsiveLayout="scroll"
          header=""
          paginator
          rows={10}
          value={userList}
          emptyMessage="No data found."
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          rowsPerPageOptions={[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
          stripedRows
        >
          <Column
            header="ID"
            body={(rowData) => (
              <div title={rowData._id} style={{ cursor: "pointer" }}>
                {`${rowData._id.slice(0, 6)}...${rowData._id.slice(-6)}`}
              </div>
            )} ></Column>

          <Column body={nameTemp} header="Name"></Column>
          <Column field="phone" header="Phone"></Column>
          <Column
            field="email"
            header="Email"
            body={(rowData) => {
              const email = rowData.email;
              const maxLength = 15; // Define the maximum visible characters
              const shortenedEmail =
                email.length > maxLength
                  ? `${email.substring(0, maxLength)}...`
                  : email;

              return (
                <span
                  className="email-cell"
                  title={email} // Tooltip for full email
                >
                  {shortenedEmail}
                </span>
              );
            }}
          ></Column>

          <Column field="role.title" header="Role"></Column>

          <Column body={statusTemp} header="Status"></Column>
          <Column
            header="Date Listed"
            body={(rowData) => {
              const date = new Date(rowData.createdAt);
              return date.toLocaleDateString("en-GB", {
                day: "numeric",
                month: "short",
                year: "numeric",
              });
            }}
          ></Column>
          <Column body={actionTemp} header="Action"></Column>
        </DataTable>
      </div>
    </>
  );
};

export default UserManagement;
